// Texty stránky B2B (b2bPage.js). Stránka existuje jen na CZ (`SHOP.pages.b2b`
// je na SK null) — dvojče žije kvůli tvaru (S3 #399).
export default {
  eyebrow: 'Pro firmy a řemeslníky',
  /** plovoucí štítek nad hero fotkou: „až −20 %" */
  maxOff: (pct) => 'až −' + pct + ' %',
  register: 'Registrace do B2B programu',
  tiersCta: 'Zobrazit úrovně slev',
  /** výchozí poznámka pod registračním CTA, když administrace nenese vlastní */
  note: 'Při registraci zvolte typ účtu „velkoobchodní odběratel".',
  /** předpona před poznámkou z obsahu administrace („Při registraci " + ctaNote) */
  notePrefix: 'Při registraci ',
  how: 'Jak spolupráce funguje',
  howHint: 'Ve třech krocích',
  tiers: 'Tři úrovně velkoobchodní spolupráce',
  tiersPerex:
    'Úroveň přidělujeme podle vašeho odběru za posledních 12 měsíců. Čím větší odběr, tím výhodnější ceny.',
  best: 'Nejvýhodnější',
  off: 'sleva',
  fromMoc: 'z maloobchodní ceny',
  feedTag: 'XML feed',
  feedTagSub: 'pro předprodej zboží',
  contactEyebrow: 'Navýšení spolupráce',
  contactTitle: 'Chcete lepší podmínky?',
  feedCta: 'Vyžádat XML feed',
  feedSubject: 'Žádost o XML feed',
  /** procesní kroky „Jak spolupráce funguje" (icon zůstává v kódu) */
  steps: [
    {
      title: 'Registrace odběratele',
      desc: 'Vytvoříte účet a zvolíte typ „velkoobchodní odběratel". Nutné je platné IČO a DIČ.',
    },
    {
      title: 'Schválení a zařazení',
      desc: 'Registraci ověříme a podle vašeho odběru vás zařadíme do některé z úrovní spolupráce.',
    },
    {
      title: 'Nákup za VO ceny',
      desc: 'Po přihlášení vidíte zvýhodněné velkoobchodní ceny automaticky u většiny sortimentu.',
    },
  ],
  /** poznámka pod CTA z administrace („Zvolte…" uprostřed věty malým písmenem) */
  ctaNote: (note) => note.replace(/^zvolte/i, 'zvolte'),
};
